// Configuración de acceso a S3 para el histórico de proyectos de
// "Creación de Documentación".
//
// Estas credenciales pertenecen a un usuario de IAM dedicado
// (intranet-docgen-s3-frontend) cuya política solo permite
// ListBucket/GetObject/PutObject/DeleteObject sobre el bucket
// "netjer-intranet-docgen-proyectos" — no tiene acceso a ningún otro
// recurso de la cuenta de AWS.
//
// Decisión del equipo: por ahora se acepta que estas credenciales queden
// visibles en el bundle/repositorio (solo el personal de la empresa
// accede a la intranet). Si en el futuro se requiere mayor
// confidencialidad, la alternativa recomendada es federar el login de
// Azure AD ya existente a través de un Cognito Identity Pool para emitir
// credenciales temporales en vez de esta llave estática.
export const S3_CONFIG = {
  region: "us-east-1",
  bucket: "netjer-intranet-docgen-proyectos",
  credentials: {
    accessKeyId: "AKIA2O5KPPW4W5BHBSXF",
    secretAccessKey: "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",
  },
};
